<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-building text-primary mr-2"></i>
                    Gestión de Sedes
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Sedes
                    <export-actions :rows="getHeadquartersFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="headquartersTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="headquarters"
                    :options="options"
                    :theme="theme" @filter="onFilter">
                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ path: '/admin/headquarters/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>
                </v-client-table>
            </b-card>
        </b-row>
    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications'
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import ExportActions from '@/components/ExportActions';
    import {mapState} from 'vuex';

    Vue.use(ClientTable);

    export default {
        name: 'listHeadquarters',
        components: {
            ClientTable,
            Event,
            ExportActions
        },
        created() {
            this.loadHeadquarters();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nueva Sede',
                        path: '/admin/headquarters/add',
                        brand: 'fa fa-building',
                        permissions: ['HEADQUARTERS_NEW']
                    },
                ],
                columns: ['uuid', 'code', 'name'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                        },
                        code: 'Código',
                        name: 'Nombre',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['code', 'name'],
                    filterable: ['code', 'name'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    },

                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        computed: {
            ...mapState([
                'headquarters'
            ]),
          headquarters: {
            get: function () {
              return this.$store.state.headquarters.list;
            },
            set: function (val) {
              this.$store.commit('SET_HEADQUARTERS_LIST', val);
            }
            //return this.$store.state.headquarters.list
          }
        },
        methods: {
            loadHeadquarters() {
                this.$_loadingMixin_showLoading();
                this.$store.dispatch('loadHeadquarters').finally(() => {
                  let searchValue = this.$store.getters.getTextFilter;
                  if (searchValue === null || searchValue === '') {
                   //console.log(this.headquarters)
                  }  else {
                    document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                    let filteredLists = []
                    this.headquarters.map(function (e) {
                      if (e.code === searchValue || e.name.includes(searchValue)) {
                        filteredLists.push(e)
                      }
                    });
                    this.headquarters = filteredLists;
                  }
                  this.$_loadingMixin_hideLoading();
                });
            },
            getHeadquartersFilteredData() {
                if (!!this.$refs.headquartersTable) {
                    return this.$refs.headquartersTable.allFilteredData.map(item => ({
                        'Código': item.code,
                        'Nombre': item.name
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.loadHeadquarters();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Registrado con éxito',
                message: 'Bienvenido a ATA Cloud'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Algo salió mal'
            }
        },
    }
</script>

<style>
    .fit {
        width: 25px;
        white-space: nowrap;
    }

    .nowrap {
        white-space: nowrap;
        width: auto !important;
    }

</style>
